module.exports = __webpack_public_path__ + "img/extension-puzzle-outline.1f7a99ef.svg";